import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { compose } from "redux";
import enhancer from "./enhancer/reportEnhancer";
import NavigationActions from "redux/navigation/actions";
import Loader from "components/Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getExcelReport } from "services/requestServices";
import moment from "moment";
import { getAllVenues } from "services/venueServices";
import Select from "react-select";

const { success, error } = NavigationActions;
const Reports = props => {
  const {
    values,
    handleBlur,
    errors,
    touched,
    submitCount,
    isValid,
    handleSubmit,
    setFieldValue,
    resetForm,
    token
  } = props;
  const [loading, setLoading] = useState(false);
  const [userTimezone, setUserTimezone] = useState("");
  const [venueList, setVenueList] = useState([]);

  const getVenueHandler = useCallback(async () => {
    setLoading(true);
    const data = {};
    await getAllVenues(token, data)
      .then(res => {
        setVenueList(res?.data);
        setLoading(false);
      })
      .catch(err => {
        error(err.message);
        setLoading(false);
      });
  });

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  // const handleReportSubmit = async (e) => {
  //   e.preventDefault();

  //   handleSubmit();
  //   if (isValid) {
  //     setLoading(true);
  //     const venueIds = values.selected_venues.map(venue => venue.value);
  //     await getExcelReport(token, {
  //       start_date: values.start_date,
  //       end_date: moment(values.end_date).endOf("day"),
  //       userTimezone: userTimezone,
  //       venues: venueIds
  //     }).then(res => {
  //       console.log("checkreport", JSON.stringify(res));
  //       if (res.message === "Success") {
  //         console.log(
  //           res,
  //           "check50",
  //           `${process.env.REACT_APP_BACKEND_URL}/${res.data}`
  //         );
  //         const createA = document.createElement("a");
  //         createA.setAttribute(
  //           "href",
  //           `${process.env.REACT_APP_BACKEND_URI}${res.data}`
  //         );
  //         createA.setAttribute("download", "Reports.xlsx");
  //         document.body.appendChild(createA);
  //         createA.click();
  //         // resetForm();
  //         setLoading(false);
  //       } else {
  //         error(res.message);
  //         setLoading(false);
  //       }
  //     });
  //   }
  // };

  // Utility function to introduce a pause
  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

  const handleReportSubmit = async e => {
    e.preventDefault();

    handleSubmit();
    if (!isValid) return; // Exit if validation fails

    setLoading(true);
    const venueIds = values.selected_venues.map(venue => venue.value);

    try {
      // Await the API call for cleaner error handling
      const res = await getExcelReport(token, {
        start_date: values.start_date,
        end_date: moment(values.end_date).endOf("day"),
        userTimezone: userTimezone,
        venues: venueIds
      });

      console.log("checkreport", JSON.stringify(res));

      if (
        res.message === "Success" &&
        res.data &&
        res.data.files &&
        Array.isArray(res.data.files)
      ) {
        const filesToDownload = res.data.files;
        const downloadDelayMs = 500; // Recommended delay of 500ms between downloads

        console.log(
          `Downloading ${filesToDownload.length} files with a ${downloadDelayMs}ms delay between each...`
        );

        // Use a for...of loop to properly await the delay for each file
        for (const file of filesToDownload) {
          // 1. Create a temporary anchor element
          const createA = document.createElement("a");

          // 2. Set the href and download attributes
          createA.setAttribute("href", file.url);
          createA.setAttribute("download", file.fileName);

          // 3. Append to the document body (required for the click to work reliably)
          document.body.appendChild(createA);

          // 4. Programmatically click the link to start the download
          createA.click();

          // 5. Clean up: remove the element immediately
          document.body.removeChild(createA);

          console.log(`Triggered download for: ${file.fileName}`);

          // 6. WAIT before triggering the next download
          await delay(downloadDelayMs);
        }

        setLoading(false);
        // resetForm();
      } else if (res.message === "Success" && res.data) {
        // Fallback for old single file format
        console.log("Single file download (Fallback)");
        const createA = document.createElement("a");
        createA.setAttribute(
          "href",
          `${process.env.REACT_APP_BACKEND_URI}${res.data}`
        );
        createA.setAttribute("download", "Reports.xlsx");
        document.body.appendChild(createA);
        createA.click();
        document.body.removeChild(createA);
        setLoading(false);
      } else {
        error(res.message || "An unknown error occurred.");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error downloading reports:", err);
      error("Failed to download reports. Check console for details.");
      setLoading(false);
    }
  };

  useEffect(() => {
    const userTime = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setUserTimezone(userTime);
  }, []);

  useEffect(() => {
    const timeOutId = setTimeout(() => getVenueHandler(), 1000);
    return () => clearTimeout(timeOutId);
  }, []);

  return (
    <>
      <div className="row mx-0">
        {/* New Venue Dropdown */}
        <div className="col-12 form-group">
          <div>
            <label>Select Venues</label>
          </div>
          <Select
            name="selected_venues"
            options={venueList
              .filter(venue => venue.status === true)
              .map(venue => ({
                value: venue.id,
                label: venue.name
              }))}
            isMulti
            value={values.selected_venues}
            onChange={selectedOptions => {
              setFieldValue("selected_venues", selectedOptions);
            }}
            onBlur={handleBlur}
            placeholder="Select one or more venues..."
          />
          <div>
            <Error field="selected_venues" />
          </div>
        </div>
      </div>

      {/* Date Pickers */}
      <div className="row mx-0">
        <div className="col-12 col-sm-auto form-group">
          <div>
            <label>
              Start Date<span className="red">*</span>
            </label>
          </div>
          <DatePicker
            peekPriviousMonth
            showMonthDropdown
            showYearDropdown
            name="start_date"
            id="start_date"
            selected={values.start_date}
            dateFormat="yyyy/MM/dd"
            className="form-control react-form-input"
            value={values.start_date}
            onChange={date => {
              setFieldValue("start_date", date);
              // Clear end date if start date changes to maintain logical flow
              if (date && moment(values.end_date).isBefore(date)) {
                setFieldValue("end_date", "");
              }
            }}
            onBlur={handleBlur}
            maxDate={new Date()}
          />
          <div>
            <Error field="start_date" />
          </div>
        </div>
        <div className="col-12 col-sm-auto form-group">
          <div>
            <label>
              End Date<span className="red">*</span>
            </label>
          </div>
          <DatePicker
            peekPriviousMonth
            showMonthDropdown
            showYearDropdown
            name="end_date"
            id="end_date"
            selected={values.end_date}
            dateFormat="yyyy/MM/dd"
            className="form-control react-form-input"
            onChange={date => {
              setFieldValue("end_date", date);
            }}
            onBlur={handleBlur}
            // Ensure minDate is the selected start_date
            minDate={values.start_date}
            maxDate={new Date()}
          />
          <div>
            <Error field="end_date" />
          </div>
        </div>
      </div>
      <div className="col form-group">
        <Button
          onClick={e => handleReportSubmit(e)}
          disabled={isValid ? false : true}
          className="btn form-button modaladdbutton"
          style={{ width: "unset" }}
        >
          Generate Report
        </Button>
      </div>
      {loading ? <Loader /> : ""}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  enhancer,
  connect(mapStateToProps, { success, error })
)(Reports);
